// Ported from CustodialView's src/App.jsx (PhotoThumbGrid) — already fully
// generic, no changes needed beyond moving it here.
export default function PhotoThumbGrid({ urls }) {
  if (!urls.length) return null;
  return (
    <div style={{ display:"grid", gridTemplateColumns:"repeat(3, 1fr)", gap:"8px", marginBottom:"14px" }}>
      {urls.map((u,i)=>(
        <img key={i} src={u} alt="" style={{ width:"100%", aspectRatio:"1", objectFit:"cover", borderRadius:"8px", border:"1px solid #E2E8F0" }} />
      ))}
    </div>
  );
}
